export const KEYWORDS = [
  'ペット仏壇',
  'ペット仏具',
  '遺骨カプセル',
  '線香',
  'ライト',
  'メモリアルグッズ',
  'お盆',
];
